export default {
  props: {
    text: {
      type: String,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('showPopup');
    },
  },
};
